// Indirection layer: everything in views/components imports from here, never directly from
// api.ts/sse.ts. VITE_MOCK=1 (or `npm run dev:mock` / `npm run build:mock`) swaps the real
// fetch client + SSE stream for src/mock.ts's fixture-backed implementations, so the whole kiosk
// can be clicked through with no FastAPI server running (DESIGN.md section 9).
import * as realApi from './api'
import * as realSse from './sse'
import * as mock from './mock'

export const USE_MOCK = import.meta.env.VITE_MOCK === '1'

const impl = USE_MOCK ? mock : realApi
const sseImpl = USE_MOCK ? mock : realSse

export const { ApiRequestError } = realApi

export const identityResolve = impl.identityResolve
export const getPlayers = impl.getPlayers
export const getPlayer = impl.getPlayer
export const createGuest = impl.createGuest
export const getMatchTypes = impl.getMatchTypes
export const createMatch = impl.createMatch
export const getMatches = impl.getMatches
export const getMatch = impl.getMatch
export const postPoint = impl.postPoint
export const undoPoint = impl.undoPoint
export const abandonMatch = impl.abandonMatch
export const swapSides = impl.swapSides
export const finalizeGameFast = impl.finalizeGameFast
export const getTable = impl.getTable
export const getRankings = impl.getRankings
export const getVersus = impl.getVersus
export const getHeadToHead = impl.getHeadToHead
export const createTournament = impl.createTournament
export const getTournaments = impl.getTournaments
export const getTournament = impl.getTournament
export const addTournamentParticipant = impl.addTournamentParticipant
export const removeTournamentParticipant = impl.removeTournamentParticipant
export const generateBracket = impl.generateBracket
export const postVoiceSample = impl.postVoiceSample
export const getVoiceProfiles = impl.getVoiceProfiles
export const rebuildVoiceProfile = impl.rebuildVoiceProfile
export const getTrainingProgress = impl.getTrainingProgress
export const putTrainingProgress = impl.putTrainingProgress
export const voiceConfirmNameTtsUrl = impl.voiceConfirmNameTtsUrl
export const postVoiceConfirmationInteraction = impl.postVoiceConfirmationInteraction
export const rollCallTtsUrl = impl.rollCallTtsUrl
export const postRollCallInteraction = impl.postRollCallInteraction

export const getTtsVoices = impl.getTtsVoices
export const getTtsTemplates = impl.getTtsTemplates
export const ttsPreviewUrl = impl.ttsPreviewUrl
export const ttsSpeakUrl = impl.ttsSpeakUrl
export const getTtsCache = impl.getTtsCache
export const ttsCacheAudioUrl = impl.ttsCacheAudioUrl
export const purgeTtsCacheEntry = impl.purgeTtsCacheEntry
export const purgeAllTtsCache = impl.purgeAllTtsCache
export const getTtsEvents = impl.getTtsEvents

export const subscribeTableEvents = sseImpl.subscribeTableEvents

export type { CreateMatchPayload, GetMatchesParams } from './api'
